module.exports = __webpack_public_path__ + "static/media/asset_icon_blue.6e7ece63.png";